import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'nestedValue',
    standalone: false
})
export class NestedValuePipe implements PipeTransform {
    transform(item: any, property: string): any {
        const splitProperties: string[] = property.split('.');
        let res = item;
        splitProperties.forEach((prop) => {
            res = res?.[prop];
        });
        return res;
    }
}
